addEventListener("DOMContentLoaded", () => {
  ankerLink();
  hamburgerMenu();
  resizeReload();
});

const ankerLink = () => {
  const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');

  for (let i = 0; i < smoothScrollTrigger.length; i++) {
    smoothScrollTrigger[i].addEventListener("click", (e) => {
      e.preventDefault();

      let href = smoothScrollTrigger[i].getAttribute("href");
      let targetElement = document.getElementById(href.replace("#", ""));

      const header = document.querySelector("header");
      const headerHeight = header.offsetHeight;

      const rect = targetElement.getBoundingClientRect().top;
      const offset = window.pageYOffset;
      const target = rect + offset - headerHeight;

      window.scrollTo({
        top: target,
        behavior: "smooth",
      });
    });
  }
};

const pageTop = () => {
  const stickyElement = document.getElementById("btnTop");
  const footerElement = document.querySelector(".p-footer");

  // stickyElement.style.display = 'none';
  stickyElement.style.trnasition = "opacity 0.3s";
  stickyElement.style.opacity = 0;
  stickyElement.style.cursor = "default";

  window.addEventListener("scroll", function () {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    const footerHeight = footerElement.offsetHeight;
    const footerWidth = footerElement.offsetWidth;

    // スクロール位置の確認
    if (scrollTop > 300) {
      stickyElement.style.opacity = 1;
      stickyElement.style.cursor = "pointer";
    } else {
      stickyElement.style.opacity = 0;
      stickyElement.style.cursor = "default";
    }
  });
};
if (document.getElementById("btnTop")) {
  pageTop();
}

const hamburgerMenu = () => {
  const header = document.getElementById("header");
  const trigger = document.getElementById("menuBtn");
  const menu = document.getElementById("gNav");
  const main = document.getElementById("main");
  const mq = window.matchMedia("(max-width: 768px)");
  const headerHeight = header.clientHeight;

  // メイン要素のマージンと高さを更新する
  const updateMarginAndHeight = () => {
    if (mq.matches) {
      main.style.marginTop = headerHeight + "px";
    } else {
      main.style.marginTop = headerHeight + "px";
    }
  };

  // メニューを開閉する
  const toggleMenu = () => {
    trigger.classList.toggle("is-active");
    menu.classList.toggle("is-active");
  };

  // イベントを登録
  updateMarginAndHeight();
  mq.addEventListener("change", updateMarginAndHeight);
  window.addEventListener("resize", updateMarginAndHeight);
  trigger.addEventListener("click", toggleMenu);
};

const resizeReload = () => {
  const breakpoints = [
    window.matchMedia("(min-width: 768px)"),
    window.matchMedia("(min-width: 1024px)"),
    window.matchMedia("(min-width: 1280px)"),
  ];
  breakpoints.forEach((breakpoint) => {
    breakpoint.addEventListener("change", () => {
      window.location.reload();
    });
  });
};
resizeReload();

document.querySelectorAll(".js-vehicle").forEach((item) => {
  item.addEventListener("click", () => {
    item.classList.toggle("is-active");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  if (!document.getElementById("mvSlider")) {
    return;
  }
  const splide = new Splide("#mvSlider", {
    type: "fade",
    rewind: true,
    autoplay: true,
    perPage: 1,
    speed: 600,
    interval: 3000,
    arrows: false,
    pagination: false,
    pauseOnHover: false,
    easing: "ease-in-out",
  });
  splide.mount();
});

document.addEventListener("DOMContentLoaded", function () {
  // #gallerySliderが存在しない場合は処理を終了
  if (!document.getElementById("gallerySlider")) {
    return;
  }
  const splide = new Splide("#gallerySlider", {
    mediaQuery: "min",
    fixedWidth: "24rem",
    gap: 16,
    type: "loop",
    arrows: false,
    drag: "free",
    flickPower: 300,
    pagination: false,
    autoScroll: {
      speed: 0.5,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
  });

  splide.mount(window.splide.Extensions);
});

document.addEventListener("DOMContentLoaded", function () {
  const accordion = document.querySelectorAll(".js-accordion");

  accordion.forEach((accordionItem) => {
    const trigger = accordionItem.querySelector(".js-accordionTrigger");
    const content = accordionItem.querySelector(".js-accordionContent");

    trigger.addEventListener("click", () => {
      trigger.classList.toggle("is-active");
      content.classList.toggle("is-active");
    });
  });
});
